// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__mA8Pc","colCheckbox":"styles_colCheckbox__3XiLd"};